import React, { useContext } from 'react';
import isFunction from 'lodash/isFunction';
import useMultistep from '../hooks/useMultistep';
import useMultistepStep from '../hooks/useMultistepStep';
import Adapter from './Adapter';
import { MultistepApiContext } from '../Context';

export default function Multistep({ children }) {
  const { render, ...context } = useMultistep();

  if (isFunction(children)) {
    return render(children(context));
  }

  return render(children);
}

Multistep.Step = function MultistepStep({ children, ...props }) {
  const { render } = useMultistepStep(props);

  return render(children);
};

Multistep.Action = function MultistepAction({ name, args = [], ...props }) {
  const multistepApi = useContext(MultistepApiContext);
  const handleClick = () => {
    return isFunction(multistepApi[name]) ? multistepApi[name](...args) : null;
  };

  return <Adapter component="Button" type="button" onClick={handleClick} {...props} />;
};
